import React, { useState } from 'react';
import axios from "axios";
import parse from "html-react-parser";
import { mrbgStore } from './mrbg/mrbgRedux/index.js'

function WorkWithUsForm({mainStyle}) {

  const
    [msg,setMsg] = useState(''),
    handleSubmit = (e) => {
      e.preventDefault();
      var MD = new FormData(e.target.closest('form'));

      if( document.getElementByDataID('mrbgLoader') )
        document.getElementByDataID('mrbgLoader').style.display='block';

      axios(
        {
          url: `${mrbgStore.getState().url}/Api/Dispatcher.php${window.location.search}`,
          method: 'POST',
          headers: {
            MrbgTk  : localStorage.getItem('token'),
            MrbgOr  : 'mailTo',
            MrbgOp  : 'mailTo',
            MrbgPath: window.location.pathname
          },
          data: MD
        }
      )
        .then (res=>{
          if( document.getElementByDataID('mrbgLoader') )
            document.getElementByDataID('mrbgLoader').removeAttribute('style');
          setMsg( res.data )
        });
    };

  return (
    <section id={mainStyle.workWithUsSec} className={mainStyle.prl_Y}>
      <div id={mainStyle.workWithUsFrame}>
        <div id={mainStyle.h2Frame}>
          <h2>work with us</h2>
          <div>Fill out this form to apply for our work opportunities.</div>
        </div>
        <form id={mainStyle.workWithUsForm} className={mainStyle.flexRowDesk} onSubmit={e=>handleSubmit(e)}>
          <fieldset>
            <legend>First Name</legend>
            <input type="text" name="firstName" required/>
          </fieldset>
          <fieldset>
            <legend>Last Name</legend>
            <input type="text" name="lastName" required/>
          </fieldset>
          <fieldset>
            <legend>Field of Study</legend>
            <input type="text" name="studyField" required/>
          </fieldset>
          <fieldset>
            <legend>Last Degree</legend>
            <input type="text" name="lastDegree" required/>
          </fieldset>
          <fieldset>
            <legend>Interested In</legend>
            <input type="text" name="interestedIn" required/>
          </fieldset>
          <fieldset>
            <legend>Birth Date</legend>
            <input type="date" name="birthDate" required/>
          </fieldset>
          <fieldset>
            <legend>Gender</legend>
            <label>
              Female <input type="radio" name="gender" value="female"/>
            </label>
            <label>
              Male <input type="radio" name="gender" value="male"/>
            </label>
          </fieldset>
          <fieldset>
            <legend>Mobile Number</legend>
            <input type="tel" name="mobile" required/>
          </fieldset>
          <fieldset>
            <legend>Email</legend>
            <input type="email" name="email" required/>
          </fieldset>
          <fieldset className={mainStyle.wide}>
            <legend>Message</legend>
            <textarea name="message" rows={4} required></textarea>
          </fieldset>
          <div className={mainStyle.blogFormMsgBox}>
            {parse(msg)}
          </div>
          <fieldset className={mainStyle.wide}>
            <button type="submit">Submit</button>
          </fieldset>
        </form>
      </div>
    </section>
  );
}

export default WorkWithUsForm;